import { render, staticRenderFns } from "./FilialGet.vue?vue&type=template&id=f4fa1ca0&scoped=true"
import script from "./FilialGet.vue?vue&type=script&lang=js"
export * from "./FilialGet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4fa1ca0",
  null
  
)

export default component.exports